import { IconButton } from "@surya-digital/leo-reactjs-material-ui";
import { X } from "lucide-react";
import { observer } from "mobx-react";
import { Instance } from "mobx-state-tree";
import React from "react";
import { SurveyRuleModel } from "../../models/SurveyRuleModel";

interface SurveyRuleConditionActionButtonsProps {
  rule: Instance<typeof SurveyRuleModel>;
  conditionId: string;
}

export const SurveyRuleConditionActionButtons: React.FC<SurveyRuleConditionActionButtonsProps> =
  observer(({ rule, conditionId }) => {
    return (
      <IconButton
        name="deleteCondition"
        size="large"
        icon={<X />}
        variant="plain-neutral"
        onClick={() => rule.removeCondition(conditionId)}
      />
    );
  });
